import React from 'react';
import { Reveal } from './Reveal';
import { Countdown } from './Countdown';
import { CTAButton } from './CTAButton';
const included = ['1 Volume Complet', '5 Outils Complémentaires', '+500 Supports Cliniques', '+150 Activités Techniques', 'Accès à vie'];
export function PricingPack() {
  return <section className="w-full bg-ink-soft px-4 py-10 sm:py-12" data-id="element-158">
      <Reveal className="mx-auto max-w-3xl" data-id="element-159">
        <div id="pack" className="scroll-mt-4 overflow-hidden rounded-3xl border border-gold/40 bg-ink-card" data-id="element-160">
          <div className="border-b border-ink-border bg-gold/10 px-6 py-4 text-center sm:px-8" data-id="element-161">
            <h2 className="font-display text-2xl uppercase leading-tight text-white sm:text-3xl" data-id="element-162">
              🏆 Le protocole clinique en 4 étapes™ — Pack complet
            </h2>
            <p className="mt-1 text-sm font-semibold text-white/70" data-id="element-163">
              1 Volume Principal + 5 Outils Complémentaires
            </p>
          </div>

          <div className="px-6 py-6 text-center sm:px-8 sm:py-7" data-id="element-164">
            <p className="text-sm text-white/50 line-through" data-id="element-165">
              Valeur totale : 112€
            </p>
            <div className="mt-1 flex items-baseline justify-center gap-2" data-id="element-166">
              <span className="font-display text-6xl text-gold sm:text-7xl" data-id="element-167">
                27€
              </span>
              <span className="text-lg font-semibold text-white/70" data-id="element-168">
                une seule fois
              </span>
            </div>
            <div className="mt-2 inline-block rounded-full bg-grass/20 px-5 py-2 text-base font-extrabold tracking-wide text-grass sm:text-lg" data-id="element-169">
              ÉCONOMISEZ 85€
            </div>
            <p className="mt-2 text-sm font-semibold uppercase tracking-wide text-white/60" data-id="element-170">
              Accès à vie
            </p>

            <ul className="mx-auto mt-5 max-w-sm space-y-2 text-left" data-id="element-171">
              {included.map(item => <li key={item} className="flex items-center gap-3 text-white/85" data-id="element-172">
                  <span className="text-base" data-id="element-173">✅</span>
                  <span className="text-sm sm:text-base" data-id="element-174">{item}</span>
                </li>)}
            </ul>

            <div className="mt-5 rounded-xl border border-ink-border bg-black/40 px-4 py-2.5 text-sm text-white/70" data-id="element-175">
              Se termine dans : <Countdown variant="inline" data-id="element-176" />
            </div>

            <div className="mt-5" data-id="element-177">
              <CTAButton pulse data-id="element-178">
                🚀 Je veux accéder au kit maintenant — 27€
              </CTAButton>
            </div>

            <p className="mt-3 text-sm text-white/55" data-id="element-179">
              Soutenu par notre garantie de remboursement de 7 jours.
            </p>

            <div className="mt-4 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm text-white/60" data-id="element-180">
              <span data-id="element-181">🔒 Paiement sécurisé</span>
              <span data-id="element-182">⚡ Accès immédiat</span>
              <span data-id="element-183">🛡️ Garantie 7 jours</span>
              <span data-id="element-184">💳 Carte · PayPal · Virement</span>
            </div>
            <p className="mt-3 text-xs text-white/40" data-id="element-185">
              💱 Vous serez facturé dans votre devise locale.
            </p>
          </div>
        </div>
      </Reveal>
    </section>;
}